import React, { Component, Fragment } from 'react';
import classnames from 'classnames';
import CheckBox from '../../components/checkbox';

class SettingContainer extends Component {
    render() {
        const {type, saveOnClick, rowAdd, refreshOnClick, handleUserShow} = this.props;
        
        
        const isVisible = ['info-user', 'info-path', 'info-fmt'];
        return (
            <div className='setting-container'>
                <div className='filter'>
                    <div className="item" onClick={refreshOnClick}><span className="icon refresh"></span> 새로고침</div>
                    {isVisible.indexOf(type) > -1 &&
                    <Fragment>
                        <div></div>
                        <div className="item" onClick={e=> handleUserShow("add")}><span className="icon add"></span> 추가</div>
                    </Fragment>
                    }
                    {/* <div></div>
                    <div className="item" onClick={handleSaveOnClick}><span className="icon del"></span> 삭제</div> */}
                    
                </div>
                <ListContainer {...this.props}/>
            </div>
        );
    }
}

const ListContainer = ({fmtList, type, headerData, userList, list, handleOnChange, 
    handleOnPathTest, listRef, handleUserShow, hadnleUserDel}) => {
 
    return (
        <div className="list-wrap" ref={listRef}>
            <table className="list">
                <thead>
                    <tr className="header">
                        {headerData.map(th => {
                            return <th className={th.id.toLowerCase()} key={`th_${th.id}`}>{th.title}</th>;
                        })}
                        {type === 'info-ch' &&<th className="empty" key={`th_mt`}></th>}
                    </tr>
                </thead>
                <tbody>
                        {list.length > 0 && list.map((data, idx) => {
                            return (
                                <tr key={`tr_${idx}`}>
                                    <ContentComponent 
                                        infoType={type}
                                        data={data}
                                        userList={userList}
                                        fmtList={fmtList}
                                        idx={idx} 
                                        headerData={headerData} 
                                        handleOnChange={handleOnChange}
                                        handleOnPathTest={handleOnPathTest}
                                        handleUserShow={handleUserShow}
                                        hadnleUserDel={hadnleUserDel}
                                    />
                                </tr>
                            );
                        })}
                </tbody>

            </table>
        </div>
    );
}

const authName = (auth) => {
    switch(auth){
        case "G":
            return "게스트";
        case "U":
            return "사용자";
        case "A":
            return "관리자";
        default:
            return "";
    }
}

const ContentComponent = ({infoType, data, userList, fmtList, idx, headerData, 
    handleOnChange, handleOnPathTest, handleUserShow, hadnleUserDel}) => {
    const handleSaveOnClick = () => {
        let msg = "사용자를 정말 삭제하시겠습니까?";
        if (window.confirm(msg) === true) hadnleUserDel(data.ID);
        else return;
    };
    let resolutionValue = "nHD";
    // 해상도 값 구하기
    if(data.WIDTH === "640" && data.HEIGHT === "360") resolutionValue = "nHD";
    else if(data.WIDTH === "940" && data.HEIGHT === "540") resolutionValue = "qHD";
    else if(data.WIDTH === "1280" && data.HEIGHT === "720") resolutionValue = "HD";
    else if(data.WIDTH === "1600" && data.HEIGHT === "900") resolutionValue = "HD+";
    else if(data.WIDTH === "1920" && data.HEIGHT === "1080") resolutionValue = "FHD";
    else resolutionValue = "nHD";
    
    const componentType = (type) => {
        let typeDiv;
        let typeEvent;
        switch(type){
            case 'NUM':
                typeDiv = idx + 1;
            break;
            case 'USEYN':
            case 'DELYN':
                // return <CheckBox id={`${idx}_${type}Check`} type={type} idx={idx} key={`td_${type}_${idx}`} checked={data[type] === 'Y'} handleOnClick={handleOnChange} />;
                typeDiv = <button type="button">삭제</button>;
                typeEvent = {
                    onClick: handleSaveOnClick
                }
            break;
            case 'AUTH':
                // return (
                //     <select value={data[type]} key={`td_${type}_${idx}`} onChange={e => handleOnChange(e, type, idx)}>
                //         <option value='G'>게스트</option>
                //         <option value='U'>사용자</option>
                //         <option value='A'>관리자</option>
                //     </select>
                // );
                typeDiv = <span key={`td_${type}_${idx}`}> {authName(data[type])} </span>
            break;
            case 'PWD':
            case 'HOSTPWD':
                typeDiv = <input type="password" key={`td_${type}_${idx}`} onChange={e => handleOnChange(e, type, idx)} value={data[type]} />;
            break;
            case 'ID':
                // if(infoType === 'info-fmt' || infoType === 'info-path' || (infoType === 'info-user' && data.ADDYN !== 'Y' ) ) return data[type];
                // else return <input type="text" key={`td_${type}_${idx}`} onChange={e => handleOnChange(e, type, idx)} value={data[type]} />;
                typeDiv =  <span key={`td_${type}_${idx}`}> {(data[type])} </span>;
                typeEvent = {
                    onClick: e=>handleUserShow("edit", data)
                }
            break;
            case 'BITRATE':
                typeDiv = <Fragment><input type="text" key={`td_${type}_${idx}`} onChange={e => handleOnChange(e, type, idx)} value={data[type]} /> <span>Kbps</span></Fragment>;
            break;
            case 'TYPE':
                typeDiv = (
                    <select value={data[type]} key={`td_${type}_${idx}`} onChange={e => handleOnChange(e, type, idx)}>
                        <option value='U'>UNC</option>
                        <option value='F'>FTP</option>
                    </select>
                );
            break;
            case 'chName':
            case 'NAME':
            case 'MEMO':
                typeDiv = data[type];
            break;
            case 'fmtid':
                typeDiv = (
                    <select value={data[type]} key={`td_${type}_${idx}`} onChange={e => handleOnChange(e, type, idx)}>
                        <option value='0'>선택</option>
                        {fmtList.length > 0 && fmtList.map(fmt => {
                            return fmt.ID && fmt.USEYN === 'Y' && <option value={fmt.ID} key={`option_${type}_${fmt.ID}`}>{fmt.NAME}</option>;
                        })}
                    </select>
                )
            break;
            case 'TEST':
                typeDiv = <span onClick={e => handleOnPathTest(data)}>테스트</span>;
            break;
            case 'RESOLUTION':
                typeDiv = (
                    <select value={resolutionValue} onChange={e => handleOnChange(e, type, idx)}>
                        <option value='nHD'>640 X 360</option>
                        <option value='qHD'>960 X 540</option>
                        <option value='HD'>1280 X 720</option>
                        <option value='HD+'>1600 X 900</option>
                        <option value='FHD'>1920 X 1080</option>
                    </select>
                )
            break;
            default:
                typeDiv = <input className={classnames({ 'edit-100': type === 'MEMO' || type === 'HOST' })} type="text" key={`td_${type}_${idx}`} onChange={e => handleOnChange(e, type, idx)} value={data[type]} />;
            break;
        }
        return <td className={type.toLowerCase()} key={`td_${type}_$i{dx}`} {...typeEvent}>{typeDiv}</td>;
    }
    return (
        <Fragment>
            {headerData.map( (td, i) => {
                return componentType(td.id);
            })}
            {infoType === 'info-ch' && <td className="empty" key={`td_mt${idx}`}></td>}
        </Fragment>
    );
}

export default SettingContainer;


// WEBPACK FOOTER //
// ./src/containers/setting/SettingContainer.js